import { KeyedObject } from 'bernie-core/dist/source';

export enum NavigationId {
  FLIGHT = 'flight',
  PACKAGE = 'package'
}

export function getNavigationIdFromQuery(query?: KeyedObject): NavigationId {
  return query && query.packageType && query.misId ? NavigationId.PACKAGE : NavigationId.FLIGHT;
}
